import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";

// CharacterAvatar: Avatar display for character entities only
interface CharacterAvatarProps {
  name: string;
  avatar_url?: string;
  className?: string; // Pass size and color via className
}

export const CharacterAvatar = ({
  name,
  avatar_url,
  className = "",
}: CharacterAvatarProps) => (
  <Avatar className={`overflow-hidden rounded-4xl ${className}`}>
    <AvatarImage
      src={avatar_url}
      alt={name}
      className="object-cover w-full h-full"
    />
    <AvatarFallback className="text-white text-xl font-bold bg-sylvain-blue">
      {name?.[0]}
    </AvatarFallback>
  </Avatar>
);
